const StatusLevelType = {
  OK: 0,
  INFO: 1,
  WARNING: 2,
};

export default StatusLevelType;
